import {gql} from '@apollo/client'

export const UPDATE_STATE_EU = gql`
  mutation updateState($id: ID!, $stateData: state_input!) {
    updateState(id: $id, stateData: $stateData) {
      success
      state {
        id
        name
        code
        jurisdictionType
        urlAcaQuote
      }
      errors {
        field
        message
      }
    }
  }
`
